module.exports = __webpack_public_path__ + "img/40_00_000_810.0744be03.jpg";